// extracted by mini-css-extract-plugin
export var showMoreIcon = "styles-module--showMore-icon--15348";
export var showMoreText = "styles-module--showMore-text--1bfe6";
export var showMoreWrapper = "styles-module--showMore-wrapper--85552";
export var suptitle = "styles-module--suptitle--94229";